import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, RouteProps } from 'react-router-dom';

import { WithData } from './context/DataContext';
import LineupPage from './views/LineupPage';
import BookmarksPage from './views/BookmarksPage';
import ItineraryPage from './views/ItineraryPage';
import ExplorePage from './views/ExplorePage';
import OffersPage from './views/OffersPage';
import MessagesPage from './views/MessagesPage';
import InformationPage from './views/InformationPage';
import Navigation from './views/Navigation';
import { WithFavorites } from './context/FavoritesContext';
import DetailsDecider from './views/DetailsDecider';
import { WithQueryStrings } from './context/QueryStringContext';

import './styles/styles.scss';
import 'animate.css';
import { WithGlobalControls } from './context/GlobalControlsContext';
import { NaveganteTemplateConfig } from '../..';
import { WithApp } from './context/AppContext';

export interface AppProps {
  config: NaveganteTemplateConfig;
}

function App(props: AppProps) {
  return (
    <Router basename={props.config.viewUrl}>
      <Switch>
        <RouteWrapper {...props} path="/bookmarks" component={BookmarksPage} />
        <RouteWrapper {...props} path="/itinerary" component={ItineraryPage} />
        {props.config.visibleTabs.includes('lineup') && (
          <RouteWrapper {...props} path="/lineup" component={LineupPage} />
        )}
        {props.config.visibleTabs.includes('explore') && (
          <RouteWrapper {...props} path="/explore" component={ExplorePage} />
        )}
        {props.config.visibleTabs.includes('offers') && (
          <RouteWrapper {...props} path="/offers" component={OffersPage} />
        )}
        {props.config.visibleTabs.includes('messages') && (
          <RouteWrapper {...props} path="/messages" component={MessagesPage} />
        )}
        {props.config.visibleTabs.includes('information') && (
          <RouteWrapper {...props} path="/information" component={InformationPage} />
        )}
        <Redirect path="*" to={`/${props.config.visibleTabs[0] || ''}`} />
      </Switch>
    </Router>
  );
}

interface RouteWrapperPropsBase {}
type RouteWrapperProps = RouteWrapperPropsBase & AppProps & RouteProps;

function RouteWrapper(props: RouteWrapperProps) {
  const { component, ...rest } = props;
  const Component = component as typeof React.Component;

  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 10);
  }, [props.path]);

  return (
    <Route
      {...rest}
      render={p => (
        <WithApp config={props.config}>
          <WithGlobalControls>
            <WithQueryStrings {...p}>
              <WithData>
                <WithFavorites>
                  <Navigation {...p} />
                  <DetailsDecider {...p} />
                  <Component {...p} />
                </WithFavorites>
              </WithData>
            </WithQueryStrings>
          </WithGlobalControls>
        </WithApp>
      )}
    />
  );
}

export default App;
